import { render, staticRenderFns } from "./reward.info.vue?vue&type=template&id=ee0397bc&scoped=true&"
import script from "./reward.info.vue?vue&type=script&lang=js&"
export * from "./reward.info.vue?vue&type=script&lang=js&"
import style0 from "./reward.info.vue?vue&type=style&index=0&id=ee0397bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee0397bc",
  null
  
)

export default component.exports